<template>
  <div class="d-flex flex-column">
    <SidebarItem
      class="order-md-0 order-3"
      text="Downloads"
      to="/aluno"
    >
      <template #icon>
        <use xlink:href="#icon-download" />
      </template>
    </SidebarItem>
  </div>
</template>
<script>

import SidebarItem from "./SidebarItem";

export default {
  components:{
    SidebarItem,
  },
}
</script>
